"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PackageBuilder = void 0;
var account_plan_terms_20240118_package_1 = require("./account-plan-terms-20240118.package");
var package_enum_1 = require("./package-enum");
var service_contract_terms_20221225_package_1 = require("./service-contract-terms-20221225.package");
var service_contract_terms_20230418_package_1 = require("./service-contract-terms-20230418.package");
var PackageBuilder = /** @class */function () {
  function PackageBuilder() {}
  PackageBuilder.createInstance = function (values) {
    if (values.package in PackageBuilder.map) {
      var _ctor = PackageBuilder.map[values.package];
      return _ctor.createInstance(values);
    }
    throw new Error("Package '".concat(values.package, "' not supported: ") + JSON.stringify(values, null, 2));
  };
  PackageBuilder.map = (_a = {}, _a[package_enum_1.PackageEnum.ServiceContractTerms20221225Package] = service_contract_terms_20221225_package_1.ServiceContractTerms20221225.Package, _a[package_enum_1.PackageEnum.ServiceContractTerms20230418Package] = service_contract_terms_20230418_package_1.ServiceContractTerms20230418.Package, _a[package_enum_1.PackageEnum.AccountPlanTerms20240118Package] = account_plan_terms_20240118_package_1.AccountPlanTerms20240118.Package, _a);
  return PackageBuilder;
}();
exports.PackageBuilder = PackageBuilder;
